<template>
  <div>
    <div
      class="subscribeFooter"
      :class="{
        'footer-container-tab': isFromTab,
        'footer-android-big': isAndroid && !isFromTab,
        v2_member_global_padding: isEasyInfoTest,
      }"
    >
      <div class="btn-container">
        <rich-button @click="joinSubscribe">
          <div class="btn_box">
            <span>{{ $t('FoodC_V2_qWhb_IjVg' /**订阅 */) }}</span>
            <div v-if="validDateDesc" class="footer-info-time">
              {{ validDateDesc }}
            </div>
          </div>
        </rich-button>
      </div>
    </div>
    <subscribe-join
      v-model="isShowJoinSubscribePopup"
      :membership="membership"
      @onJoinSuccess="handleJoinSuccess"
    />
  </div>
</template>

<script>
import SubscribeJoin from '@/page/member/components-v2/subscribe-join.vue'
import { SUCCESS_TYPE } from '@/page/member/common/enumsUtil.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'SubscribeFooter',
  components: {
    SubscribeJoin,
  },
  mixins: [mixin],
  inject: ['initCodeData'],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
    headInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowJoinSubscribePopup: false,
    }
  },
  computed: {
    brandName() {
      return this.membership?.brandName
    },
    validDateDesc() {
      return this.headInfo?.validDateDesc
    },
  },
  methods: {
    joinSubscribe() {
      this.isShowJoinSubscribePopup = true
    },
    async handleJoinSuccess() {
      this.isShowJoinSubscribePopup = false

      await this.initCodeData()

      const joinSuccessDialogData = {
        data: this.membership?.renewDate,
        price: this.membership?.renewPriceSplit?.display,
      }
      this.$emit('onSuccess', {
        dialogData: joinSuccessDialogData,
        type: SUCCESS_TYPE.subscription,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.subscribeFooter {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 100%;
  background: #ffffff;
  padding: 16px 24px 71px 24px;
  box-sizing: border-box;
  // border-radius: 40px 40px 0 0;
  // box-shadow: 0px -10px 48px 0px rgba(0, 0, 0, 0.06);
  .footer-info-time {
    width: 98%;
    margin-top: 4px;
    height: 32px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    @include ellipsis(1);
  }
  .rich-btn {
    height: 120px;
    border-radius: 40px;
    background: #ff5f14;
  }
  .btn_box {
    width: 100%;
    span {
      font-family: DiDiSans-Pro-ExtraBold;
      font-weight: normal;
      font-size: 48px;
      color: #fff;
    }
  }

  &.footer-android-big {
    padding-bottom: 40px;
  }

  &.footer-container-tab {
    padding-top: 16px;
    padding-bottom: 16px;
    .rich-btn {
      height: 104px;
      border-radius: 32px;
    }
    .btn_box {
      span {
        font-size: 40px;
      }
    }
    .footer-info-time {
      font-size: 20px;
    }
  }
}
</style>
